export default __webpack_public_path__ + "static/media/998.d9909fd1.png";